/* eslint-disable react/no-unknown-property */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './icon.css';

export class IconSet extends PureComponent {
    constructor(props) {
        super(props);
        this.tagsEnabled =
            (window.MDTSetting &&
                window.MDTSetting.features &&
                window.MDTSetting.features.iconTagsEnabled) ||
            false;
    }

    render() {
        const { className, name, btnRef, title, titleRequired, dataTest } = this.props;
        const classes = className || '';
        const defaultTitle = typeof t === 'function' ? t(`icon.${name}`) : `icon.${name}`;
        const iconTitle = titleRequired && this.tagsEnabled ? title || defaultTitle : '';
        return (
            <span className={`mdt-icon ${classes}`} face={name} ref={btnRef} data-test={dataTest}>
                <span title={iconTitle} className={`icon-${name}`} />
            </span>
        );
    }
}

IconSet.propTypes = {
    name: PropTypes.string,
    titleRequired: PropTypes.bool,
    dataTest: PropTypes.string,
};

IconSet.defaultProps = {
    name: 'mail',
    titleRequired: true,
    dataTest: 'mdtIconset',
};
export default IconSet;

export const NotificationIcon = ({
    iconCount,
    iconWhenNotification,
    iconEmpty,
    className,
    onIconClicked,
    dataTest = 'notification-icon',
}) => {
    const classes = classNames('badge', { large: iconCount > 99 });
    return (
        <div className={`notification-icon ${className}`} data-test={dataTest}>
            <a onClick={onIconClicked} href='#' data-test='notofication-icon-link'>
                <IconSet name={iconCount > 0 ? iconWhenNotification : iconEmpty} />
                {iconCount > 0 && <span className={classes}>{iconCount}</span>}
            </a>
        </div>
    );
};

NotificationIcon.propTypes = {
    iconWhenNotification: PropTypes.string.isRequired,
    iconEmpty: PropTypes.string.isRequired,
    iconCount: PropTypes.number,
    onIconClicked: PropTypes.func,
    className: PropTypes.string,
    dataTest: PropTypes.string,
};
